import { useState } from 'react';
import clsx from 'clsx';
import { Button, useMediaQuery, type ButtonProps } from '@ag1/ui';
import { type ImageAndSliderButtons } from 'types/studio/studio';
import { PlusIcon } from '@ag1/ui';
import SliderButtonModal from './SliderButtonModal/SliderButtonModal';
import styles from './SliderButton.module.scss';

interface SliderButtonProps {
  sliderButtonItem: Pick<
    NonNullable<ImageAndSliderButtons['sliderButtonItems']>[number],
    | 'label'
    | 'superHeadline'
    | 'sliderImage'
    | 'headline'
    | 'subtitle'
    | 'paragraph'
    | 'listTitle'
    | 'list'
    | 'items'
  >;
  sliderButtonItems?: ImageAndSliderButtons['sliderButtonItems'];
  hasSliderArrows?: boolean;
  hasSliderDividers?: boolean;
  sliderButtonVariant?: ButtonProps['variant'];
  useRegularButton?: boolean;
}

export const SliderButton = ({
  sliderButtonItem,
  sliderButtonItems,
  hasSliderArrows,
  hasSliderDividers,
  sliderButtonVariant = 'primary',
  useRegularButton
}: SliderButtonProps) => {
  const [opened, setOpened] = useState(false);
  const [selected, setSelected] = useState(sliderButtonItem);

  const handleClick = () => {
    setOpened(true);
    setSelected(sliderButtonItem);
  };

  const atMedium = useMediaQuery('m');

  return (
    <>
      {useRegularButton ? (
        <Button variant={sliderButtonVariant} onClick={handleClick} rounded>
          {sliderButtonItem?.label}
        </Button>
      ) : (
        <button
          type="button"
          className={clsx(styles.button, styles[sliderButtonVariant])}
          onClick={handleClick}>
          <span>{sliderButtonItem?.label}</span>
          <span className={styles.btnIcon}>
            <PlusIcon
              size={atMedium ? 56 : 48}
              color="inherit"
              strokeWidth={1}
              hasPadding={false}
            />
          </span>
        </button>
      )}
      {opened && (
        <SliderButtonModal
          opened
          selected={selected}
          setSelected={setSelected}
          sliderButtonItems={sliderButtonItems}
          closeSlideout={() => setOpened(false)}
          hasSliderArrows={hasSliderArrows}
          hasSliderDividers={hasSliderDividers}
        />
      )}
    </>
  );
};
